export const gtm1BooksyCardReader = {
  eventBCRStartedHandler ({ data }) {
    const { stripe_kyc_status } = data
    return {
      event: 'BCR_Started',
      properties: {
        stripe_kyc_status,
      },
    }
  },

  eventBCRVerifyHandler () {
    return {
      event: 'BCR_Verify',
    }
  },

  eventBCRStripeKYCStartedHandler () {
    return {
      event: 'BCR_Stripe_KYC_Started',
    }
  },

  eventBCROrderTerminalStartedHandler () {
    return {
      event: 'BCR_Order_Terminal_Started',
    }
  },

  eventBCRBuySubscriptionFromBCRHandler () {
    return {
      event: 'BCR_Buy_Subscription_From_Bcr',
    }
  },

  eventBCRBackToPaymentTypesHandler () {
    return {
      event: 'BCR_Back_To_Payment_Types',
    }
  },

  eventBCRResetAccountStartedHandler () {
    return {
      event: 'BCR_Reset_Account_Started',
    }
  },

  eventBCRBackToBooksyCardReaderHandler () {
    return {
      event: 'BCR_Back_To_Booksy_Card_Reader',
    }
  },

  eventBCRUpdateInformationWhenPendingHandler () {
    return {
      event: 'BCR_Update_Information_When_Pending',
    }
  },

  eventBCRUpdateInformationWhenNotVerifiedHandler () {
    return {
      event: 'BCR_Update_Information_When_Not_Verified',
    }
  },

  eventBCRHowItWorksHandler () {
    return {
      event: 'BCR_How_It_Works',
    }
  },

  eventBCRLearnMoreHandler () {
    return {
      event: 'BCR_Learn_More',
    }
  },

  eventBCRContactUsHandler () {
    return {
      event: 'BCR_Contact_Us',
    }
  },

  eventBCRConnectedAccountAgreementHandler () {
    return {
      event: 'BCR_Connected_Account_Agreement',
    }
  },

  eventBCRCardReaderConnectionInProgressHandler ({ data }) {
    const { onboarding_status } = data
    return {
      event: 'BCR_Card_Reader_Connection_In_Progress',
      properties: {
        onboarding_status,
      },
    }
  },

  eventBCRCardReaderConnectHandler ({ data }) {
    const {
      stripe_bcr_connection_reader_type,
      stripe_bcr_software_version,
      stripe_bcr_reader_SN,
      stripe_bcr_connection_terminal_status,
      stripe_bcr_connection_terminal_type,
      stripe_bcr_connetion_ip_adress,
      stripe_bcr_failure_reason,
      stripe_bcr_failure_code,
    } = data

    return {
      event: 'BCR_Card_Reader_Connect',
      properties: {
        stripe_bcr_connection_reader_type,
        stripe_bcr_software_version,
        stripe_bcr_reader_SN,
        stripe_bcr_connection_terminal_status,
        stripe_bcr_connection_terminal_type,
        stripe_bcr_connetion_ip_adress,
        stripe_bcr_failure_reason,
        stripe_bcr_failure_code,
      },
    }
  },

  eventBCRCardReaderActionHandler ({ data }) {
    const {
      screen_name,
      event_action,
      // reader_too_long_busy event
      reader_serial_number,
      payment_intent,
    } = data

    return {
      event: 'Booksy_Card_Reader_Action',
      properties: {
        screen_name,
        event_action,
        reader_serial_number,
        payment_intent,
      },
    }
  },
}
